import LegalLayout, { H2, H3, P, UL } from "./LegalLayout";

export default function Confidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité" lastUpdated="Février 2026">
      <P>
        La présente politique décrit comment <b>MJSA INVEST</b>, éditeur du logiciel <b>PitBoard</b>,
        collecte, utilise et protège vos données personnelles, conformément au Règlement Général
        sur la Protection des Données (RGPD - UE 2016/679) et à la loi française Informatique et Libertés.
      </P>

      <H2>1. Responsable du traitement</H2>
      <P>
        <b>MJSA INVEST</b><br />
        Adresse : [À compléter — adresse du siège social MJSA INVEST]<br />
        SIRET : [À compléter — SIRET MJSA INVEST]<br />
        Email DPO : <a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>
      </P>

      <H2>2. Données collectées</H2>
      <H3>Données d'identification</H3>
      <UL>
        <li>Nom, prénom, adresse email (via authentification Google)</li>
        <li>Raison sociale, SIRET, adresse postale, téléphone (saisis dans votre profil entreprise)</li>
      </UL>
      <H3>Données métier</H3>
      <UL>
        <li>Clients, devis, factures, articles, ouvrages, stock, charges, salariés</li>
        <li>Documents PDF générés (devis, factures, fiches chantier)</li>
      </UL>
      <H3>Données techniques</H3>
      <UL>
        <li>Adresse IP, type de navigateur, dates de connexion (logs serveur, conservés 12 mois)</li>
        <li>Cookies techniques nécessaires au fonctionnement (session, préférences)</li>
      </UL>
      <H3>Données de paiement</H3>
      <P>
        <b>Aucune donnée de carte bancaire n'est stockée par PitBoard.</b> Les paiements sont traités
        exclusivement par Stripe Payments Europe Ltd (PCI-DSS niveau 1). Nous ne conservons que
        l'identifiant de session Stripe et le statut du paiement.
      </P>

      <H2>3. Finalités du traitement</H2>
      <UL>
        <li>Fourniture du Service (création de devis, factures, gestion de l'activité)</li>
        <li>Facturation et recouvrement de l'abonnement</li>
        <li>Support client par email</li>
        <li>Sécurité (détection de fraude, prévention des intrusions)</li>
        <li>Amélioration du Service (analyse anonyme d'usage)</li>
      </UL>

      <H2>4. Bases légales (RGPD art. 6)</H2>
      <UL>
        <li><b>Exécution du contrat</b> : fourniture du Service, facturation, support</li>
        <li><b>Obligation légale</b> : conservation des factures (10 ans, art. L.123-22 Code de commerce)</li>
        <li><b>Intérêt légitime</b> : sécurité et amélioration du Service</li>
        <li><b>Consentement</b> : envoi d'emails marketing optionnels (que vous pouvez retirer à tout moment)</li>
      </UL>

      <H2>5. Destinataires des données</H2>
      <P>
        Vos données ne sont jamais vendues. Elles peuvent être partagées avec :
      </P>
      <UL>
        <li><b>Stripe</b> (paiement) — Irlande, conforme RGPD</li>
        <li><b>Resend</b> (envoi d'emails transactionnels) — Conforme RGPD, hébergement UE/US sous clauses contractuelles types</li>
        <li><b>Hébergeur</b> : [À préciser : MongoDB Atlas EU / OVH / Scaleway], hébergement Union Européenne</li>
        <li><b>Google</b> (authentification OAuth) — sous clauses types Google Workspace</li>
        <li><b>Autorités</b> : uniquement sur demande légale dûment formée</li>
      </UL>

      <H2>6. Transferts hors UE</H2>
      <P>
        Aucun transfert de données personnelles hors UE/EEE n'a lieu sans garanties appropriées
        (clauses contractuelles types de la Commission européenne, décisions d'adéquation).
      </P>

      <H2>7. Durée de conservation</H2>
      <UL>
        <li><b>Données de compte</b> : pendant toute la durée de l'abonnement + 30 jours</li>
        <li><b>Factures et données comptables</b> : 10 ans (obligation légale)</li>
        <li><b>Logs techniques</b> : 12 mois</li>
        <li><b>Données après résiliation</b> : suppression sur demande dans un délai de 30 jours, sauf obligations légales</li>
      </UL>

      <H2>8. Sécurité</H2>
      <UL>
        <li>Chiffrement TLS 1.2+ pour tous les échanges réseau</li>
        <li>Chiffrement au repos (AES-256) sur les bases de données</li>
        <li>Sauvegardes quotidiennes chiffrées</li>
        <li>Isolation multi-tenant : chaque entreprise n'accède qu'à ses propres données</li>
        <li>Authentification OAuth 2.0 via Google (pas de mot de passe stocké chez nous)</li>
      </UL>

      <H2>9. Vos droits</H2>
      <P>Conformément au RGPD, vous disposez des droits suivants :</P>
      <UL>
        <li><b>Accès</b> : obtenir une copie de vos données</li>
        <li><b>Rectification</b> : corriger des données inexactes</li>
        <li><b>Effacement</b> (« droit à l'oubli ») : suppression de vos données, sauf obligations légales</li>
        <li><b>Limitation</b> : restreindre certains traitements</li>
        <li><b>Portabilité</b> : récupérer vos données dans un format structuré (CSV/JSON)</li>
        <li><b>Opposition</b> : refuser le traitement à des fins d'intérêt légitime ou de marketing</li>
        <li><b>Définir des directives</b> post-mortem sur vos données</li>
      </UL>
      <P>
        Pour exercer ces droits : <a href="mailto:contact@pitboard-app.fr" className="underline">contact@pitboard-app.fr</a>.
        Réponse sous 30 jours maximum.
      </P>

      <H2>10. Réclamation</H2>
      <P>
        Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation
        auprès de la CNIL : <a href="https://www.cnil.fr/" target="_blank" rel="noopener noreferrer" className="underline">www.cnil.fr</a>.
      </P>

      <H2>11. Cookies</H2>
      <P>
        PitBoard utilise uniquement des cookies <b>techniques strictement nécessaires</b> au
        fonctionnement (session de connexion, préférences). Aucun cookie publicitaire ni traceur tiers.
        Aucun consentement préalable n'est requis pour les cookies essentiels.
      </P>

      <H2>12. Modifications</H2>
      <P>
        Cette politique peut être mise à jour. Vous serez notifié par email en cas de changement
        substantiel au moins 30 jours avant son entrée en vigueur.
      </P>
    </LegalLayout>
  );
}
